import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService, HomePageService, TenantService } from '@core/service';
import { Tenant } from '@mynexus/mynexus-ui-lib';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss'],
    standalone: false
})
export class WelcomePageComponent implements OnInit, OnDestroy {
  userName: string;
  isTenantMultiple = true;
  tenantName: string = null;
  subs = new SubSink();
  contentPage = {};
  isLoading = false;

  public tenants: Tenant[];

  get isContentLoaded(): boolean {
    return Object.keys(this.contentPage).length > 0;
  }

  constructor(
    public authenticationService: AuthenticationService,
    private tenantService: TenantService,
    private homePageService: HomePageService,
  ) { }

  ngOnInit(): void {
    window.history.replaceState({}, document.title, '/home');
    this.getTenants();
    this.userName = `${this.authenticationService.claims.given_name} ${this.authenticationService.claims.family_name}`;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private getContentPage(tenantId: string) {
    this.contentPage = {};
    this.subs.sink = this.homePageService.getContentByHealthPlan(tenantId).subscribe(content => {
      if (content && content.content) {
        JSON.parse(content.content).forEach(block => {
          this.contentPage[block.id] = block.content;
        });
      } else {
        this.contentPage['welcome'] = 'No Data';
        this.contentPage['updates'] = '';
        this.contentPage['provider'] = '';
        this.contentPage['additional'] = '';
        this.contentPage['forms'] = '';
        this.contentPage['manuals'] = '';
      }

    });
  }

  getTenants() {
    this.subs.sink = this.tenantService.getTenants(this.authenticationService.isExternalUser).subscribe(
      res => {
        this.tenants = res;
        this.isLoading = true;
      },
      () => {
        // eslint-disable-next-line no-console
        console.error('Error: Unable to retrieve tenants');
      }
    );
  }

  routeToPlan(tenant: Tenant) {
    this.isTenantMultiple = false;
    this.tenantName = tenant.name;
    this.getContentPage(tenant.tenantId);
  }

}
